import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const waitTwoSeconds = () => new Promise(r => setTimeout(r, 2000));
const emailTranslationConfig = {
  id: 'email-ai-translation-coaching-tips',
  beforeEnter: waitTwoSeconds,
  tips: [{
    tipId: 'generate-translated-version',
    attachTo: '[data-test-id="email-title-cell"] div',
    placement: 'top right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "emailTranslation.title"
    }),
    cta: {
      text: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "emailTranslation.cta"
      }),
      handler: () => {
        const closeButton = document.querySelector('[data-test-id="coaching-tip-popover-close-button"]');
        if (closeButton) {
          closeButton.click();
        }
        const hoverContent = document.querySelector('[data-test-id="email-title-cell"] .table-hover-content');
        const mouseEvent = new MouseEvent('mouseenter', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        hoverContent === null || hoverContent === void 0 || hoverContent.dispatchEvent(mouseEvent);
        const actionsDropdown = document.querySelector('[data-test-id="actions-button"]');
        if (actionsDropdown) {
          actionsDropdown.click();
        }
      }
    },
    steps: [{
      content: /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "emailTranslation.content"
        })
      })
    }],
    zIndex: 1111
  }]
};
export default emailTranslationConfig;